import { formatDate, isValidDateString } from 'utils'

export const formatUpdatedValue = (value: any) => (isValidDateString(value) ? formatDate(value) : value)
